


export const validateFields = (fields,type=1) => {

    let pass = true;

    let validation_fields = [
        'datalogics_fullname',
        'datalogics_phone',
        'datalogics_address',
        // 'datalogics_house',
        'datalogics_city'
    ];

    if (type==2) {
        validation_fields = [
            'shipping_push_supplier_code',
            'shipping_push_supplier_name',
            'shipping_push_supplier_phone',
            'shipping_mark_fullfiled',
            'shipping_push_products_in_comments'
        ]
    }

    for(let key in fields) {

        //console.log(key,validation_fields.indexOf(key),fields[key]);

        if (validation_fields.indexOf(key)!==-1) {

            if (fields[key]=='') {
                pass = false;
            }

        } 

    }

    return pass;
    

}